import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import CustomTable from "../../../../../Components/common/Table/CustomTable";
import { snortsuricata, snortsuricataReport } from "../../../../../utils/constants/tableHeaders";
import { getNetworkAlertFields } from "./utils/snortSuricataUtil";

import "./styles.scss";

const SnortSuricata = ({ report = false }) => {
  const [alerts, setAlerts] = useState([]);
  const snortsuricataRef = useRef(null);

  const snortSuricataAlerts = useSelector((state) => state.analysisReports.snortSuricataAlerts);

  useEffect(() => {
    if (snortSuricataAlerts) {
      setAlerts(getNetworkAlertFields(snortSuricataAlerts));
    }
  }, [snortSuricataAlerts]);

  if (alerts.length === 0) {
    return (
      <div className={report ? "snort-suricata snort-suricata--report" : "snort-suricata"}>
        <div
          className="map-footer"
          style={{
            background: "var(--card-background-color)",
            height: "100%",
          }}>
          <div className="snort-suricata__no-data__header">
            <p className="snort-suricata__no-data__item">Source IP </p>
            <p className="snort-suricata__no-data__item">Destination IP</p>
            <p className="snort-suricata__no-data__item">Type</p>
            <p className="snort-suricata__no-data__item">CN</p>
            <p className="snort-suricata__no-data__item">Signature/Messages</p>
          </div>
          <div
            className="map-footer__header-item"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              // fontFamily: "Nunito Sans",
              fontSize: "14px",
              fontWeight: "600",
              color: "#grey--text",
              textAlign: "center",
              textTransform: "uppercase",
              height: "100%",
              width: "100%",
            }}>
            No Data
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={report ? "snort-suricata snort-suricata--report" : "snort-suricata"}>
      <CustomTable
        dataSnortSuricata={alerts}
        tableName={"snortSuricata"}
        column={report ? snortsuricataReport : snortsuricata}
        exportFile={!report}
        paginationButtons={!report}
        refresh={!report}
        tableRef={snortsuricataRef}
        customPageSize={report ? 100 : 6}
        minHeight={report ? "auto" : 416}
        // tableBorder is inverted: true is what removes the border from the
        // table element. The default is true; passing !report here left the
        // table with its own border inside the wrapper's, so two showed up.
        reportPage={report}
        borderRadius={4}
      />
    </div>
  );
};

export default SnortSuricata;
